import i18next from '../i18n';

export default (selected) => () => {
  i18next.changeLanguage(selected);
};
